export default __webpack_public_path__ + "static/media/LoginPageIcon.7b48201d.png";